module.exports = __webpack_public_path__ + "img/second_3.0eb87154.png";